__turbopack_context__.v({
  "className": "avertafont_14c9bb3c-module__1oT8xq__className",
  "variable": "avertafont_14c9bb3c-module__1oT8xq__variable",
});
